import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LeadsCrmService } from 'src/app/leads-crm/services/leads-crm.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../msal/auth.service';
import { CommonService } from '../../services/common.service';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';


@Component({
  selector: 'app-leads-crm-sub-menu',
  templateUrl: './leads-crm-sub-menu.component.html',
  styleUrls: ['./leads-crm-sub-menu.component.scss']
})
export class LeadsCrmSubMenuComponent implements OnInit {

  @Output() closeSidebarHeader = new EventEmitter<any>();
  public url: string = '';
  menu: string = '';
  @ViewChild('changeMenuModal', {static: true})
  public changeMenuModal: SearchUpdateConfirmationComponent | any;
  public enableRentalLeadSubMenu: boolean;
  public enableBuyerLeadSubMenu: boolean;
  
  constructor(
    private leadsCrmService: LeadsCrmService,
    private router: Router,
    private commonSerice: CommonService,
    private authService: AuthService
    
  ) {
    setTimeout(() => {
      this.authService.subscribeToUrl((url: any) => {
        this.url = url;
      })
      }, 0);
      this.enableRentalLeadSubMenu = environment.enableRentalLeadSubMenu === 'true'? true: false;
      this.enableBuyerLeadSubMenu = environment.enableBuyerLeadSubMenu === 'true'? true: false;
  }

  //return the selected menu
  get selectedMenu(): string {
    return this.leadsCrmService.selectedMenu;
  }

  ngOnInit(): void {
    this.leadsCrmService.updateSelectedMenu('lead-receipt');
    if(sessionStorage.getItem('currentUrl'))
      {
        this.url = sessionStorage.getItem('currentUrl') as string;        
      }
  }





  /**
   * check if the menu is selected or not
   * @param menuItem 
   * @return boolean
   */

  public isMenuSelected(menuItem: string): boolean {
    return this.selectedMenu === menuItem;
  }


  /**
  * update the selected menu
  * @param menuItem 
  */

  public selectMenu(menuItem: string): void {
    this.menu = menuItem;
    if(this.commonSerice.getFormUpdateStatus()) {
      this.changeMenuModal.showModal();
    } else {
      this.selectMenuConfirmation();
    } 
  }

  
  /** select Menu confirmation popup event */
  selectMenuConfirmation() {
    this.commonSerice.setFormUpdateStatus(false);
    this.leadsCrmService.updateSelectedMenu(this.menu);
    this.closeSidebarHeader.emit(true);
    sessionStorage.setItem('activeUrl', '/portal/leads-crm/' + this.menu);
    this.router.navigate(['/portal/leads-crm/' + this.menu]);
  }
}

